// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__fVC5B","filesListContainer":"PosDisputesFiles_filesListContainer__2Wauz","filesButton":"PosDisputesFiles_filesButton__3jBJ4"};